import { FC } from 'react';
import DgCard from 'styles/UI/Card/DgCard';
import DgCardHeader from 'styles/UI/CardHeader/DgCardHeader';
import UserActivityFilter from './components/UserActivityFilter';
import UserActivityTable from './components/UserActivityTable';

const UsersActivity: FC = () => {
	return (
		<DgCard>
			<DgCardHeader title='users-activity' />

			<UserActivityFilter />
			<UserActivityTable />
		</DgCard>
	);
};

export default UsersActivity;
